import {
    FileText,
    BookOpen,
    Globe,
    Code,
    Lightbulb,
    AlertCircle,
    CheckSquare,
    HelpCircle,
    Megaphone,
    Heart,
    Shield,
    GraduationCap,
    Settings,
    Users,
    File,
    FolderOpen,
    Hash,
    Bookmark,
    Zap,
    Target,
} from "lucide-react";

export const ICON_MAP = {
    FileText,
    BookOpen,
    Globe,
    Code,
    Lightbulb,
    AlertCircle,
    CheckSquare,
    HelpCircle,
    Megaphone,
    Heart,
    Shield,
    GraduationCap,
    Settings,
    Users,
    File,
    FolderOpen,
    Hash,
    Bookmark,
    Zap,
    Target,
};

export const ICON_OPTIONS = Object.keys(ICON_MAP);
